import { render, staticRenderFns } from "./AdminDrawer.vue?vue&type=template&id=580a97c0&scoped=true&"
import script from "./AdminDrawer.vue?vue&type=script&lang=ts&"
export * from "./AdminDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./AdminDrawer.vue?vue&type=style&index=0&id=580a97c0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580a97c0",
  null
  
)

export default component.exports